var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryPublicFigureEntrepreneur(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category Copy 16@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-598.000000, -890.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 207.000000)",
    id: "positive-judgement"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.91304348,3.47826087 L5.91304348,3.47826087 C4.95254826,3.47826087 4.17391304,2.69962565 4.17391304,1.73913043 L4.17391304,1.73913043 C4.17391304,0.778635218 4.95254826,6.17863248e-16 5.91304348,6.17863248e-16 L5.91304348,6.17863248e-16 C6.8735387,6.17863248e-16 7.65217391,0.778635218 7.65217391,1.73913043 L7.65217391,1.73913043 C7.65217391,2.69962565 6.8735387,3.47826087 5.91304348,3.47826087 L5.91304348,3.47826087 Z",
    id: "Path",
    fill: "#5A7A84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04347826,5.56521739 C9.04347826,4.79682122 8.42057009,4.17391304 7.65217391,4.17391304 L4.17391304,4.17391304 C3.40551687,4.17391304 2.7826087,4.79682122 2.7826087,5.56521739 L2.7826087,8.69565217 L9.04347826,8.69565217 L9.04347826,5.56521739 Z",
    id: "Path",
    fill: "#335262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4782609,8.69565217 L0.347826087,8.69565217 C0.155727044,8.69565217 0,8.85137922 0,9.04347826 C0,9.2355773 0.155727044,9.39130435 0.347826087,9.39130435 L1.04347826,9.39130435 L1.04347826,15.6521739 C1.04347826,15.844273 1.1992053,16 1.39130435,16 L10.4347826,16 C10.6268817,16 10.7826087,15.844273 10.7826087,15.6521739 L10.7826087,9.39130435 L11.4782609,9.39130435 C11.6703599,9.39130435 11.826087,9.2355773 11.826087,9.04347826 C11.826087,8.85137922 11.6703599,8.69565217 11.4782609,8.69565217 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24591304,11.3763478 L5.46330435,14.1589565 C5.32747831,14.2947415 5.1073043,14.2947415 4.97147826,14.1589565 L3.58017391,12.7676522 C3.44835749,12.6311726 3.45024265,12.4142314 3.58441093,12.2800631 C3.71857921,12.1458948 3.93552039,12.1440097 4.072,12.2758261 L5.2173913,13.4212174 L7.75408696,10.8845217 C7.89056657,10.7527053 8.10750775,10.7545905 8.24167603,10.8887588 C8.3758443,11.022927 8.37772946,11.2398682 8.24591304,11.3763478 Z",
    id: "Path",
    fill: "#72C472"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryPublicFigureEntrepreneur);
export default __webpack_public_path__ + "static/media/category_public_figure_entrepreneur.8eb5038a8ea9c15e780c437e5e59f95c.svg";
export { ForwardRef as ReactComponent };